import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { IApiResponse } from "../../../AbstractApiClient/IApiResponse";
import { TGetSingleContractorPaymentAsContractorResponseSchema } from "../getSingleContractorPaymentAsContractor/getSingleContractorPaymentAsContractor.schema";

export const getContractorPaymentsAsContractor = (axios: IAxiosInstance) => {
  return async (): Promise<
    TGetSingleContractorPaymentAsContractorResponseSchema[]
  > => {
    const response = await axios.noRetry.get<
      IApiResponse<TGetSingleContractorPaymentAsContractorResponseSchema[]>
    >("/api/getContractorPaymentsAsContractor");
    const resData = response.data;

    if (resData.success) {
      return resData.data;
    }

    throw new Error("Something went wrong");
  };
};
